import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '@/environments/environment';

import {
  LoginResponseDto,
  SigninSubmitRequest,
} from 'sham-components/shared/models/auth';

const BASE_URL = `${API_BASE_URL}/api/auth`;

@Injectable({
  providedIn: 'root',
})
export class SigninApi {
  private readonly http = inject(HttpClient);

  signinSeller(
    payload: SigninSellerSubmitRequest,
  ): Observable<PendingActionResponseDto> {
    return this.http.post<PendingActionResponseDto>(
      `${BASE_URL}/signin/seller`,
      payload,
    );
  }

  login(payload: SigninSubmitRequest): Observable<LoginResponseDto> {
    return this.http.post<LoginResponseDto>(
      `${API_BASE_URL}/api/v1/auth/login`,
      payload,
    );
  }

  refreshToken(payload: {
    refreshToken: string;
  }): Observable<LoginResponseDto> {
    return this.http.post<LoginResponseDto>(
      `${API_BASE_URL}/api/v1/auth/refresh-token`,
      payload,
    );
  }
}

export interface SigninSellerSubmitRequest {
  email: string;
  password: string;
}

export interface PendingActionResponseDto {
  message: string;
}
